import { PermissionGate } from '@components/PermissionGate';
import { useBankProfile } from '@contexts/BankProfileContext';
import {
	Button,
	GlobeIcon,
	TransferIcon,
	Typography,
	UploadIcon,
} from '@gurupay/gp-ui-library';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { Capability } from 'types/roles';

import { getGreetingData } from '../utils';

export const DashboardHeader = () => {
	const isMobile = useMediaQuery({ query: '(max-width: 480px)' });
	const { t, i18n } = useTranslation('', { keyPrefix: 'dashboard' });
	const { selectedProfile } = useBankProfile();

	const { greeting, weekday, month, day, year } = getGreetingData();

	const isLT = i18n.language.startsWith('lt');

	const fullDate = isLT
		? `${t(`weekdays.${weekday}`)}, ${year} ${t(`months.${month}`)} ${day} d.`
		: `${t(`weekdays.${weekday}`)}, ${day} ${t(`months.${month}`)} ${year}`;

	return (
		<div className="bg-white p-space-24 rounded-lg">
			<Typography level="small-text">{fullDate}</Typography>
			<Typography className="text-lg sm:text-2xl" level="h1">
				{t(`greetings.${greeting}`)}, {selectedProfile?.name}
			</Typography>

			<PermissionGate capability={Capability.CREATE_PAYMENT}>
				<div className="flex gap-space-8 mt-space-16 sm:mt-space-24 overflow-x-auto py-space-4">
					<Button
						href="/payments/sepa"
						className="flex-row-reverse w-max"
						icon={<TransferIcon className="h-4 w-4" />}
						size="sm"
						variant="primary-black"
					>
						{t('quickActions.sepa')}
					</Button>

					<Button
						href="/payments/international"
						className="flex-row-reverse w-max whitespace-nowrap"
						icon={<GlobeIcon className="h-4 w-4" />}
						size="sm"
						variant="primary-black"
					>
						{t('quickActions.international')}
					</Button>

					<Button
						href="/payments/fx"
						className="flex-row-reverse w-max whitespace-nowrap"
						icon={<GlobeIcon className="h-4 w-4" />}
						size="sm"
						variant="primary-black"
					>
						{t('quickActions.fxTransfer')}
					</Button>

					{!isMobile && (
						<Button
							href="/payments/batch"
							className="flex-row-reverse w-max whitespace-nowrap"
							icon={<UploadIcon className="h-4 w-4" />}
							size="sm"
							variant="primary-black"
						>
							{t('quickActions.fileUpload')}
						</Button>
					)}
				</div>
			</PermissionGate>
		</div>
	);
};
